
import ButtonType1 from "../../components/ButtonType1/ButtonType1";
import ButtonType2 from "../../components/ButtonType2/ButtonType2";
import { activity } from "../../data/activity";

const Activity = () => {
    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20 pb-20 lg:pb-36">
            
            <div className="flex flex-col tracking-wider py-10">

                <div className="flex w-full flex-wrap justify-center mb-10">
                    <p className="text-base md:text-lg mb-2 m-3 whitespace-nowrap">
                        NFT Owned: <span className = 'text-gray-400'> 23 </span>
                    </p>
                    <p className="text-base md:text-lg mb-2 m-3 whitespace-nowrap">
                        Total Buy in USD: <span className = 'text-gray-400'> $5000 </span>
                    </p>
                    <p className="text-base md:text-lg mb-2 m-3 whitespace-nowrap">
                        Total Sell in USD: <span className = 'text-gray-400'> $8000 </span>
                    </p>
                    <p className="text-base md:text-lg mb-2 m-3 whitespace-nowrap">
                        Margin: <span className = 'text-gray-400'> $3000 </span>
                    </p>
                    <p className="text-base md:text-lg mb-2 m-3 whitespace-nowrap">
                        Balance: <span className = 'text-gray-400'> $9000 </span>
                    </p>
                </div>


                <div className="flex flex-col md:flex-row md:justify-between mb-5">
                    <div className="mb-2 md:mb-0 md:mr-3 shadow-shadow3 bg_gradient py-6 px-3 md:p-5 rounded-[8px] flex-grow">
                        <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Report</h2>
                        
                        <div className="flex flex-col xl:flex-row xl:justify-between">

                            <div className="flex w-full xl:max-w-[60%] flex-col md:flex-row items-center md:items-stretch md:justify-between">
                                <div className="w-full md:max-w-[48%] flex flex-col justify-between shadow-shadow3 bg_gradient p-4 rounded-[8px] my-3 md:m-3">
                                    <p className="text-base mb-8">
                                        Deposit
                                    </p>
                                    <p className="text-base mb-2 text-[#DE00FF]">
                                        ETH
                                    </p>
                                    <p className="text-base xl:text-lg font-[500] mb-4">
                                        9213123.123
                                    </p>
                                    <div className="flex justify-between mb-3">
                                        <p className="text-sm xl:text-base">
                                            Transactions
                                        </p>
                                        <button className="text-sm xl:text-base border-b-[1px] border-gray-400 text-gray-400">
                                            See all
                                        </button>
                                    </div>
                                    <div className="flex justify-between mb-8">
                                        <p className="text-sm xl:text-base">
                                            <span className="text-[#DE00FF]">ETH</span> 314.2123
                                        </p>
                                        <button className="text-sm xl:text-base text-gray-400 border-b-[1px] border-gray-400">
                                            taxwas..
                                        </button>
                                    </div>
                                    <div className="w-full flex justify-center mb-4">
                                        <ButtonType1 title='Deposit' className="w-[150px]"/>
                                    </div>
                                </div>
                                <div className="w-full md:max-w-[48%] flex flex-col justify-between shadow-shadow3 bg_gradient p-4 rounded-[8px] my-3 md:m-3">
                                    <p className="text-base mb-8">
                                        Earning
                                    </p>
                                    <p className="text-base mb-2 text-[#DE00FF]">
                                        ETH
                                    </p>
                                    <p className="text-base xl:text-lg font-[500] mb-4">
                                        9213123.123
                                    </p>
                                    <div className="flex justify-between mb-3">
                                        <p className="text-sm xl:text-base">
                                            Latest Sell
                                        </p>
                                        <button className="text-sm xl:text-base border-b-[1px] border-gray-400 text-gray-400">
                                            See all
                                        </button>
                                    </div>
                                    <div className="flex justify-between mb-8">
                                        <p className="text-sm xl:text-base">
                                            <span className="text-[#DE00FF]">ETH</span> 314.2123
                                        </p>
                                        <button className="text-sm xl:text-base text-gray-400 border-b-[1px] border-gray-400">
                                            taxwas..
                                        </button>
                                    </div>
                                    <div className="w-full flex justify-center mb-4">
                                        <ButtonType1 title='Withdraw' className="w-[150px]"/>
                                    </div>
                                </div>
                            </div>

                            <div className="xl:w-full xl:max-w-[40%] flex flex-col justify-between shadow-shadow3 bg_gradient p-4 rounded-[8px] my-3 md:m-3">
                                <div className="flex justify-between mb-5">
                                    <p className="text-base mb-8">
                                        Ranking
                                    </p>
                                    <p className="text-base text-[#DE00FF]">
                                        ETH
                                    </p>
                                </div>
                                <div className="flex flex-col mb-8">
                                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3">
                                        <div className="flex items-center mb-2 sm:mb-0">
                                            <p className="text-base xl:text-lg mr-2">#1</p>
                                            <img alt = 'profile' className = 'w-[30px] h-[30px] rounded-[50%] mr-2'
                                                src = 'https://images.unsplash.com/photo-1597766133770-cd88b9b8efc4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' />
                                            <p className="text-sm xl:text-base ">som@sadewf</p>
                                        </div>
                                        <p className="text-sm ml-[30px] md:ml-0 xl:text-base ">92132.2334</p>
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3">
                                        <div className="flex items-center mb-2 sm:mb-0">
                                            <p className="text-base xl:text-lg mr-2">#1</p>
                                            <img alt = 'profile' className = 'w-[30px] h-[30px] rounded-[50%] mr-2'
                                                src = 'https://images.unsplash.com/photo-1597766133770-cd88b9b8efc4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' />
                                            <p className="text-sm xl:text-base ">som@sadewf</p>
                                        </div>
                                        <p className="text-sm ml-[30px] md:ml-0 xl:text-base ">92132.2334</p>
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
                                        <div className="flex items-center mb-2 sm:mb-0">
                                            <p className="text-base xl:text-lg mr-2">#1</p>
                                            <img alt = 'profile' className = 'w-[30px] h-[30px] rounded-[50%] mr-2'
                                                src = 'https://images.unsplash.com/photo-1597766133770-cd88b9b8efc4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80' />
                                            <p className="text-sm xl:text-base ">som@sadewf</p>
                                        </div>
                                        <p className="text-sm ml-[30px] md:ml-0 xl:text-base ">92132.2334</p>
                                    </div>
                                </div>
                                <div className="w-full flex justify-center mb-4">
                                    <ButtonType1 title='See Ranking' className="w-[180px]"/>
                                </div>
                            </div>
                
                        </div>

                    </div>

                    <div className="shadow-shadow3 bg_gradient p-5 rounded-[8px]">
                        <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Currency</h2>
                        <div className="flex justify-between mb-2">
                            <p className="text-sm xl:text-base text-[#DE00FF]">ETH</p>
                            <p className="text-sm xl:text-base">$5012.12</p>
                        </div>
                        <div className="flex justify-between mb-2">
                            <p className="text-sm xl:text-base text-[#FF8A00]">BTC</p>
                            <p className="text-sm xl:text-base">$5012.12</p>
                        </div>
                        <div className="flex justify-between mb-2">
                            <p className="text-sm xl:text-base text-[#DE00FF]">ETH</p>
                            <p className="text-sm xl:text-base">$5012.12</p>
                        </div>
                        <div className="flex justify-between mb-2">
                            <p className="text-sm xl:text-base text-[#FF8A00]">BTC</p>
                            <p className="text-sm xl:text-base">$5012.12</p>
                        </div>
                        <div className="flex justify-between mb-2">
                            <p className="text-sm xl:text-base text-[#DE00FF]">ETH</p>
                            <p className="text-sm xl:text-base">$5012.12</p>
                        </div>
                    </div>

                </div>

                <div className="flex flex-col justify-between shadow-shadow3 bg_gradient p-4 rounded-[8px] my-3 md:m-3">
                    <div className="flex justify-between mb-6">
                        <h2 className="mb-5 text-xl lg:text-2xl xl:text-3xl">Report</h2>
                        <ButtonType2 title = 'Filter' className = 'px-6 h-[45px]' />
                    </div>

                    {activity.map((item, index) => {
                        return (
                            <div key={index} className="flex mb-5 flex-col lg:flex-row lg:justify-between">

                                <div className="w-full flex justify-between mr-10">
                                    <div className = 'flex items-center'>
                                        {item.type === 'withdraw' ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-[16px] h-[20px] text-white" viewBox="0 0 448 512">
                                                <path d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"/>
                                            </svg>
                                        ):(
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-[16px] h-[20px] text-white" viewBox="0 0 448 512">
                                                <path d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"/>
                                            </svg>
                                        )}
                                        <div className="flex flex-col ml-3">
                                            <p className="text-sm md:text-base capitalize text-gray-300">{item.type}</p>
                                            <p className="text-base md:text-lg">{item.amount}</p>
                                        </div>
                                    </div>
                                    <p className="text-base text-[#DE00FF]">
                                        ETH
                                    </p>
                                            
                                </div>

                                <div className="lg:w-full flex flex-wrap md:flex-nowrap justify-between ml-[27px] lg:ml-0">
                                    <p className="text-sm md:text-base text-gray-400 mr-4 overflow-hidden">
                                        {item.address}
                                    </p>
        
                                    <p className="text-sm md:text-base text-gray-400 min-w-[100px] whitespace-nowrap">
                                        {item.date}
                                    </p>

                                </div>
                             
                            </div>
                        )
                    })}

                    <div className="w-full flex justify-center my-10">
                        <ButtonType1 title = 'Load More' />
                    </div>
                    
                </div>

            </div>

        </div>
    )
}

export default Activity;